window.addEventListener('load', function(){
  
  const ham = document.querySelector('#open-menu');
  const nav = document.querySelector('#sp-menu');
  
  ham.addEventListener('click', function () {
  
    ham.classList.toggle('open');
    nav.classList.toggle('open');
  
  });

    let accordionDetails = '.js-accordion';
    let accordionSummary = '.js-accordion__title';
    let accordionContent = '.js-accordion__content';
    let speed = 400;

    $(accordionSummary).each(function (){
        $(this).on("click",function (event){
            event.preventDefault();
            if($(this).parent($(accordionDetails)).attr("open")){
                $(this).removeClass("open");
                $(this).nextAll($(accordionContent)).slideUp(speed,function (){
                    $(this).parent($(accordionDetails)).removeAttr("open");
                    $(this).show();
                });
            }else{
                $(this).addClass("open");
                $(this).parent($(accordionDetails)).attr("open","true");
                $(this).nextAll($(accordionContent)).hide().slideDown(speed);
            }
        });
    });
  
});


document.addEventListener('DOMContentLoaded', () => {

  const currentPath1 = window.location.pathname;

  if (currentPath1 === '/pages/faq') {
    $(function(){
      $('a[href^="#"]').click(function(){
        var speed = 500;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top;
        $("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
      });
    });
  };

    let accordionDetails2 = '.faq__sec details';
    let accordionSummary2 = '.faq__sec summary';
    let accordionContent2 = '.fap__details-content';
    let speed2 = 400;

    $(accordionSummary2).each(function (){
        $(this).on("click",function (event){
            event.preventDefault();
            if($(this).parent($(accordionDetails2)).attr("open")){
                $(this).removeClass("open");
                $(this).nextAll($(accordionContent2)).slideUp(speed2,function (){
                    $(this).parent($(accordionDetails2)).removeAttr("open");
                    $(this).show();
                });
            }else{
                $(this).addClass("open");
                $(this).parent($(accordionDetails2)).attr("open","true");
                $(this).nextAll($(accordionContent2)).hide().slideDown(speed2);
            }
        });
    });

  const currentPath2 = window.location.pathname;

  if (currentPath2 === '/pages/userguide' || currentPath2 === '/pages/choose_gift') {
    $(function(){
      $('a[href^="#"]').click(function(){
        var speed = 500;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top;
        $("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
      });
    });
  };

  let accordionDetails3 = '.main details';
  let accordionSummary3 = '.main summary';
  let accordionContent3 = '.userguide__details-content';
  let speed3 = 400;

    $(accordionSummary3).each(function (){
        $(this).on("click",function (event){
            event.preventDefault();
            if($(this).parent($(accordionDetails3)).attr("open")){
                $(this).removeClass("open");
                $(this).nextAll($(accordionContent3)).slideUp(speed3,function (){
                    $(this).parent($(accordionDetails3)).removeAttr("open");
                    $(this).show();
                });
            }else{
                $(this).addClass("open");
                $(this).parent($(accordionDetails3)).attr("open","true");
                $(this).nextAll($(accordionContent3)).hide().slideDown(speed3);
            }
        });
    });
  
});

document.addEventListener('DOMContentLoaded', () => {

  const currentPath3 = window.location.pathname;

  if (currentPath3 === '/pages/msad') {
    $(function(){
      $('a[href^="#"]').click(function(){
        var speed = 500;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top;
        $("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
      });
    });
  };

  if (currentPath3 === '/pages/ag' || currentPath3 === '/pages/msad') {
    $('.header .pc').hide();
    $('.header .sp').hide();
    $('.footer .pc').hide();
    $('.footer .sp').hide();
    $('.footer').css({'cssText': 'border-top: none !important;'});
  };
  
});


document.addEventListener('DOMContentLoaded', () => {
  
  const policy = document.querySelector('.shopify-policy__title');
  
  if (policy) {
    if(document.URL.match(/terms-of-service/)){
      policy.insertAdjacentHTML('afterbegin', '<p class="headtitle__en">Terms of Service</p>');
    };
    if(document.URL.match(/privacy-policy/)){
      policy.insertAdjacentHTML('afterbegin', '<p class="headtitle__en">Privacy Policy</p>');
    };
    if(document.URL.match(/legal-notice/)){
      policy.insertAdjacentHTML('afterbegin', '<p class="headtitle__en">Legal Notice</p>');
    };
  };
  
});